<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-start wrap pb-5>
      <v-flex xs12>
        <v-layout justify-start wrap pb-4>
          <v-flex xs12 sm12 md12>
            <v-layout justify-start wrap>
              <v-flex xs10 sm10 md5 text-left>
                <v-layout justify-start wrap>
                  <v-flex xs2 sm2 md1 text-start>
                    <v-img width="30px" src="../../assets/images/arrow.svg">
                    </v-img>
                  </v-flex>
                  <v-flex>
                    <span
                      style="
                        font-family: nunitosansbold;
                        font-size: 20px;
                        color: #000000;
                      "
                      >Topper Video</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout justify-start wrap>
          <v-flex xs12 sm12 md8>
            <v-layout pa-2 justify-start wrap>
              <v-flex xs12>
                <v-card elevation="0" rounded="lg" width="100%" height="500">
                  <iframe
                    :key="data.video"
                    :src="
                      'https://www.youtube.com/embed/' + data.video + '?rel=0'
                    "
                    width="100%"
                    height="100%"
                    style="border: 2; overflow: hidden"
                    scrolling="no"
                    frameborder="0"
                    allowtransparency="true"
                    allowfullscreen="true"
                  ></iframe>
                </v-card>
                <v-flex xs12>
                  <v-layout justify-center wrap>
                    <v-flex xs8>
                      <span
                        style="
                          font-family: nunitosanssemibold;
                          font-size: 14px;
                          color: #000000;
                        "
                        >{{ data.title }}</span
                      >
                    </v-flex>
                    <v-flex xs2 text-right>
                      <v-dialog
                        :retain-focus="false"
                        v-model="dialog"
                        persistent
                        max-width="800px"
                        :key="dialog"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon outlined v-bind="attrs" v-on="on">
                            mdi-content-save-edit
                          </v-icon>
                        </template>
                        <v-card>
                          <v-form>
                            <v-card-title>
                              <span>Edit Topper Video</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-layout justify-center wrap>
                                  <v-flex xs12>
                                    <v-text-field
                                      outlined
                                      dense
                                      v-model="data.title"
                                      label=" Title of the Topper Video"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      outlined
                                      dense
                                      v-model="data.video"
                                      label="Youtube Link of the Topper Video"
                                    ></v-text-field> </v-flex
                                  ><v-flex xs12>
                                    <span> Description of the Video</span>
                                    <div id="app">
                                      <vue-editor
                                        v-model="data.description"
                                      ></vue-editor>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="dialog = false"
                              >
                                Close
                              </v-btn>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="edit(data._id)"
                              >
                                Save
                              </v-btn>
                            </v-card-actions>
                          </v-form>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs2 text-right>
                      <v-dialog v-model="data.delete" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on="on"
                            v-bind="attrs"
                            right
                            overlap
                            offset-x="5"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <v-card>
                          <v-card-title style="font-family: nunitosansregular">
                            Are you sure you want to delete this Video?
                          </v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="data.delete = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="appdelete(data._id)"
                              >OK</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                  <!-- <br /> -->
                  <span
                    style="
                      font-family: nunitosansregular;
                      font-size: 10px;
                      color: #717171;
                    "
                    >{{ data.views }}</span
                  ><br />
                  <span
                    style="
                      font-family: nunitosansregular;
                      font-size: 12px;
                      color: #777676;
                    "
                    v-html="data.description"
                  ></span>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-layout justify-end wrap pt-2>
              <v-flex
                xs12
                v-for="(item, i) in list"
                :key="i"
                text-left
                pa-2
                pl-2
              >
                <v-card elevation="0" rounded="lg">
                  <iframe
                    :key="item.video"
                    :src="
                      'https://www.youtube.com/embed/' + item.video + '?rel=0'
                    "
                    width="100%"
                    height="100%"
                    style="border: 2; overflow: hidden"
                    scrolling="no"
                    frameborder="0"
                    allowtransparency="true"
                    allowfullscreen="true"
                  ></iframe>
                </v-card>
                <span
                  @click="(newId = item._id), getData()"
                  style="
                    font-family: nunitosanssemibold;
                    font-size: 14px;
                    color: #000000;
                    cursor: pointer;
                  "
                  >{{ item.title }}</span
                ><br />
                <span
                  style="
                    font-family: nunitosansregular;
                    font-size: 10px;
                    color: #717171;
                  "
                  >{{ item.text }}</span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  props: ["id"],
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      dialog: false,
      timeout: 5000,
      msg: "",
      list: [],
      data: [],
      newId: "",
    };
  },
  mounted() {
    this.newId = this.id;
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/toppervideo/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.newId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.data = response.data.data;
          this.list = response.data.suggestions;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit(item) {
      var data = {};
      data["title"] = this.data.title;
      data["description"] = this.data.description;
      data["video"] = this.data.video;
      data["id"] = item;
      axios({
        method: "post",
        url: "/toppervideo/edit",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dialog = false;
            Object.keys(this.data).forEach((key) => (this.data[key] = null));
            this.msg = "Updated Successully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    appdelete(id) {
      axios({
        method: "POST",
        url: "/toppervideo/remove",
        data: {
          id: id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          this.msg = "Video Deleted";
          this.newId = this.list[0]._id;
          this.getData();
          this.data = this.list[0];
          this.showsnackbar = true;
        }
      });
    },
  },
};
</script>